module.exports = __webpack_public_path__ + "img/ms-xbox.a8094ce4.png";